import React, { ChangeEvent, FocusEvent } from 'react';
import { Caption } from '../Caption/Caption';
import './Textarea.css';

export interface TextareaProps {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: FocusEvent<HTMLTextAreaElement>) => void;
  caption?: React.ReactNode;
  message?: string;
  messageType?: '' | 'error' | 'success';
  ariaLabel?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Textarea = React.memo(function Textarea({
  label,
  required = false,
  disabled = false,
  readonly = false,
  placeholder = '',
  value,
  onChange,
  onBlur,
  caption,
  message,
  messageType = '' as '' | 'error' | 'success',
  ariaLabel,
  size = 'md',
}: TextareaProps) {
  return (
    <div className="textarea" data-disabled={disabled} data-size={size} aria-label={ariaLabel}>
      <label>
        {label && (
          <span className="textarea__label">
            {label}
            {required && <span className="textarea__required">*</span>}
          </span>
        )}
        {caption && <Caption>{caption}</Caption>}
        <textarea
          required={required}
          readOnly={readonly}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
        />
      </label>
      {message && (
        <span className="textarea__message" data-type={messageType}>
          {message}
        </span>
      )}
    </div>
  );
});
